import assetPath from '/app/xinglets/startpage-logged-out/entry/src/deep-dive-section/assets/banner.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')